export default "__VITE_ASSET__CMO5y7vf__"